<template>
  <div class="page">
    <div class="container">

      <element-processor @submit="submit" :data="processorData" >
        <element-processor-step :data="processorData.steps[0]">
          <ul class="form-item-list">
            <li><h3>서비스 신청</h3></li>
            <li><element-select v-model="processorData.steps[0].formData.insureName.value" :error="processorData.steps[0].formData.insureName.error" :label="processorData.steps[0].formData.insureName.label" :placeholder="processorData.steps[0].formData.insureName.placeholder" :items="processorData.steps[0].formData.insureName.item"/></li>
            <li><element-textbox v-model="processorData.steps[0].formData.carNumber.value" :error="processorData.steps[0].formData.carNumber.error" :label="processorData.steps[0].formData.carNumber.label" :placeholder="processorData.steps[0].formData.carNumber.placeholder" /></li>
            <li><element-textbox v-model="processorData.steps[0].formData.name.value" :error="processorData.steps[0].formData.name.error" :label="processorData.steps[0].formData.name.label" :placeholder="processorData.steps[0].formData.name.placeholder" /></li>
            <li><element-textbox v-model="processorData.steps[0].formData.phone.value" :error="processorData.steps[0].formData.phone.error" :label="processorData.steps[0].formData.phone.label" :placeholder="processorData.steps[0].formData.phone.placeholder" /></li>

            <li class="is-multiple">
              <element-calendar v-model="processorData.steps[0].formData.consultDate.value" :error="processorData.steps[0].formData.consultDate.error" :label="processorData.steps[0].formData.consultDate.label" :placeholder="processorData.steps[0].formData.consultDate.placeholder" />
              <element-time-select v-model="processorData.steps[0].formData.consultTime.value" :date="processorData.steps[0].formData.consultDate.value" :error="processorData.steps[0].formData.consultTime.error" :label="processorData.steps[0].formData.consultTime.label" :placeholder="processorData.steps[0].formData.consultTime.placeholder" />
            </li>
            <li>
              <element-textarea v-model="processorData.steps[0].formData.consultRemark.value"
                :error="processorData.steps[0].formData.consultRemark.error"
                :label="processorData.steps[0].formData.consultRemark.label"
                :placeholder="consultRemarkPlaceHolderSet() ? consultRemarkPlaceHolderSet() :processorData.steps[0].formData.consultRemark.placeholder" />
            </li>
          </ul>
          <div class="form-item-caution">입력하신 내용을 바탕으로 상담원이 상담 전 확인 및 관련 내용을 준비하여 상담을 진행합니다.</div>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[1]">
          <include-consult-complete :data="processorData.steps[1]" />
        </element-processor-step>
        <transition name="popup">
          <element-popup @status="popup" :process_title="processorData.title" v-model="processorData.steps[1].formData.insureOptions[statusPopup.option].value" @checkPopup="checkValue" :label="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].label"
          :subLabel="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].subLabel" v-if="statusPopup.popup" :statusPopup="statusPopup" :data="processorData.steps[1].formData.insureOptions[statusPopup.option]"
          :description="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].description">
          </element-popup>
        </transition>
      </element-processor>
    </div>
  </div>
</template>
<script>

import moment from 'moment'

export default {
  props: ['service'],
  data(){
    return {
      statusPopup: {
        popup: false,
        index: '',
        option: -1,
      },
      moment: moment,
      processorData: {
        title: "서비스신청",
        steps: [
          {
            title: "서비스 신청하기",
            formData: {
              insureName: {
                label: "서비스 선택",
                value: "최저 보험료",
                error: "",
                item: [
                  { value: "최저 보험료", label: "최저 보험료" },
                  { value: "만기완결 알림", label: "만기완결 알림" },
                  { value: "청약철회 환불", label: "청약철회 환불" },
                  { value: "착오계약 리콜", label: "착오계약 리콜" },
                  { value: "24시간 근무", label: "24시간 근무" },
                  { value: "24시간 주차알림", label: "24시간 주차알림" },
                  { value: "긴급견인 20km 추가", label: "긴급견인 20km 추가" },
                  { value: "응급치료비 지원", label: "응급치료비 지원" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              carNumber: {
                label: "신청하실 차량번호",
                value: "",
                error: "",
                placeholder: "차량번호 입력(예: 12가3456), 자동차보험이 아닌 경우 비워둡니다. ",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              name: {
                label: "연락 받으실 성함",
                value: "",
                error: "",
                placeholder: "이름 입력",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              phone: {
                label: "연락 받으실 휴대폰 번호",
                value: "",
                error: "",
                placeholder: "- 없이 입력 (예:01012345678)",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultDate: {
                label: "상담일시",
                value: new Date(),
                placehodler: "날짜",
                error: "",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultTime: {
                label: "상담 예약 일시",
                value: "",
                error: "",
                placeholder: "시간",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultRemark: {
                label: "상담 전 남기실 말씀",
                value: "",
                error: "",
                placeholder: "상담 전 남기실 말씀을 입력하십시오.(200자 이내)"
              }
            }
          },
          {
            title: "서비스 신청 상담 예약이 완료되었습니다.",
            label: "예약하신 상담일시에 상담원이 친절하게 안내해 드리겠습니다."
          }
        ] // steps
      }
    }
  },
  watch: {
    'processorData.steps.0.formData.insureName.value' () {
      if(this.processorData.steps[0].formData.insureName.value != this.$route.query.tab && !this.$route.query.service)
        this.$router.replace({ query: { tab : this.processorData.steps[0].formData.insureName.value, procstep: this.$route.query.procstep }})
    }
  },
  created () {
    if(this.$route.query.tab) this.processorData.steps[0].formData.insureName.value = this.$route.query.tab
    if(this.$route.query.service) this.processorData.steps[0].formData.insureName.value = this.$route.query.service
  },
  methods: {
    submit( finalData ) {
      var reservation_data = {
        customer_id: finalData.customer_id,
        "전화상담": finalData["서비스 신청하기"]
      }
      //this.$store.dispatch( "reservation/updateItems", { data: finalData } );
      // 전화상담 예약 추가 전송
      this.$store.dispatch( "reservation/createServiceItems", reservation_data );
    },
    popup: function( status ) {
      this.statusPopup = status;
    },
    checkValue: function( value ) {
      this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].subLabel = value;

      if(this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.findIndex(o => o.label === this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value) >= 0){

        var index = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.findIndex(o => o.label === this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value);
        if(value === '미가입' && !this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].requirement){
          this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.splice(index, 1);
        }
      }else{
        if(value != '미가입'){
          var tmp = { label: this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value, value: value };
          this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.push( tmp )
        }
      }
    },
    updateprocessorData: function (value){
      this.processorData.steps[4].formData.haslogin.value = value;
    },
    consultRemarkPlaceHolderSet: function() {
      if(this.processorData.steps[0].formData.insureName.value == "24시간 주차알림") {
        return "주차알림 스티커를 받으실 우편 주소를 입력해세요. 그 외 남기실 말씀이 있으면 입력하십시오.(200자 이내)";
      }else if(this.processorData.steps[0].formData.insureName.value == "긴급견인 20km 추가") {
        return  "상담전 견인기사로 부터 받은 영수증 사진을 미리 준비해주세요. 남기실 말씀을 입력하십시오.(200자 이내)";
      }else{
        return null;
      }
    }
  }
}
</script>
